var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4987 11.6668V10.5002C13.4987 9.85583 12.9764 9.3335 12.332 9.3335C11.6877 9.3335 11.1654 9.85583 11.1654 10.5002V11.6668M14.6654 6.66683H1.33203M14.6654 7.3335V5.46683C14.6654 4.72009 14.6654 4.34673 14.52 4.06151C14.3922 3.81063 14.1882 3.60665 13.9374 3.47882C13.6521 3.3335 13.2788 3.3335 12.532 3.3335H3.46537C2.71863 3.3335 2.34526 3.3335 2.06004 3.47882C1.80916 3.60665 1.60519 3.81063 1.47736 4.06151C1.33203 4.34672 1.33203 4.72009 1.33203 5.46683V10.5335C1.33203 11.2802 1.33203 11.6536 1.47736 11.9388C1.60519 12.1897 1.80916 12.3937 2.06004 12.5215C2.34526 12.6668 2.71863 12.6668 3.46536 12.6668H7.33203M11.0654 14.3335H13.5987C13.9721 14.3335 14.1588 14.3335 14.3014 14.2608C14.4268 14.1969 14.5288 14.0949 14.5927 13.9695C14.6654 13.8269 14.6654 13.6402 14.6654 13.2668V12.7335C14.6654 12.3601 14.6654 12.1734 14.5927 12.0308C14.5288 11.9054 14.4268 11.8034 14.3014 11.7395C14.1588 11.6668 13.9721 11.6668 13.5987 11.6668H11.0654C10.692 11.6668 10.5053 11.6668 10.3627 11.7395C10.2373 11.8034 10.1353 11.9054 10.0714 12.0308C9.9987 12.1734 9.9987 12.3601 9.9987 12.7335V13.2668C9.9987 13.6402 9.9987 13.8269 10.0714 13.9695C10.1353 14.0949 10.2373 14.1969 10.3627 14.2608C10.5053 14.3335 10.692 14.3335 11.0654 14.3335Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfid);
export default __webpack_public_path__ + "static/media/rfid.f6157c08e2cf6146809383ab952ad3a4.svg";
export { ForwardRef as ReactComponent };